var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{text-align:center;padding-top:6em}.icon{width:30px}.icon,.insta{vertical-align:middle;padding-right:7px}.insta{width:40px}.gap{margin-right:20px}.in{background:url(" + escape(require("../assets/linkedin.png")) + ") no-repeat}.in:hover{background:url(" + escape(require("../assets/linkedin1.png")) + ") no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66e88645","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer.vue
// module id = 28
// module chunks = 0